module.exports = __webpack_public_path__ + "media/customizations/westphalia/back-1cb873c25e9d8627a9bac64f226f3c7c.jpg";